module.exports = {"id":"223332","name":"Mattia Sprocati","rating":"71","photo":"./data/images/photos/1/223332.png","club":{"name":"Salerne","logo":"./data/images/clubs/Salerne.png"},"positions":["AG","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MattiaSprocati0.json
// module id = 2912
// module chunks = 0